import { render, staticRenderFns } from "./updateGoodsInfo.vue?vue&type=template&id=08a19933&scoped=true&"
import script from "./updateGoodsInfo.vue?vue&type=script&lang=ts&"
export * from "./updateGoodsInfo.vue?vue&type=script&lang=ts&"
import style0 from "./updateGoodsInfo.vue?vue&type=style&index=0&id=08a19933&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a19933",
  null
  
)

export default component.exports